<template lang="pug">
  v-container#foot(fluid)
    //v-layout(row wrap justify-center align-center)
      img#large.credits(src="../assets/credits.png")
      img#mobile.credits(src="../assets/credits_mobile.png")
    v-footer#footer.main-background
      v-layout(row wrap justify-center align-center)
        //v-flex(text-xs-right)
          strong.accent-text-pink Página web&nbsp;
          | www.--------
        v-flex.mr-5.white-text(text-xs-right)
          i.mr-2(class="fab fa-twitter fa-lg") 
          | @cedehm
        v-flex.ml-5.white-text(text-xs-left)
          span.mr-2(class="fa-stack")
            i(class="fas fa-circle fa-stack-2x")
            i.fb(class="fab fa-facebook-f fa-stack-1x fa-inverse back")
          | facebook.com/CentroCEDEHM/

</template>

<style lang="scss">
#footer {
  color: #fff;
  font-family: "Open Sans", sans-serif;
  padding: 1rem;
  height: 95px !important;
  font-size: 17px;
}

#foot {
  padding: 0;
}

.credits {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-height: 200px;
  min-height: 140px;
  max-width: 100%;
}

#mobile {
  display: none;
}

.fb {
  color: #752c7d;
}

@media (max-width: 600px) {
  #mobile {
    display: block;
  }
  #large {
    display: none;
  }
}
</style>

<script>
export default {
  name: "Footer",
  props: {}
};
</script>
